import {useStorage} from "@variocube/app-ui";
import * as React from "react";
import {createContext, ReactNode, useEffect} from "react";

const PREFIX = "cloud.smalox.com/";

interface ClientIdHolder {
	clientId?: string;
}

const ClientIdContext = createContext<ClientIdHolder>({
	clientId: undefined,
});

interface ClientIdProviderProps {
	children: ReactNode;
}

export function ClientIdProvider({children}: Readonly<ClientIdProviderProps>) {
	const [clientIdHolder, setClientIdHolder] = useStorage<ClientIdHolder>("clientId", {});

	useEffect(() => {
		if (clientIdHolder.clientId) {
			return;
		}
		const clientId = generateClientId();
		setClientIdHolder({clientId: `${PREFIX}${clientId}`});
	}, [clientIdHolder, setClientIdHolder]);

	return (
		<ClientIdContext.Provider value={clientIdHolder}>
			{children}
		</ClientIdContext.Provider>
	);
}

export function useClientId() {
	const {clientId} = React.useContext(ClientIdContext);
	return clientId;
}

function generateClientId(): string {
	const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let result = "";
	for (let i = 0; i < 16; i++) {
		const randomIndex = Math.floor(Math.random() * chars.length);
		result += chars[randomIndex];
	}
	return result;
}
